import React from "react";
import classNames from "classnames";
import { FormPostSubmitType } from "../../../../../shared/types";
import CloseIcon from "../../../../../shared/icons/CloseIcon";
import styles from "./FeedbackMessage.module.scss";
const FeedbackMessage = ({
  success,
  failure,
  formSettings,
  resetForm,
  text
}) => {
  const successMessage = formSettings?.formPostSubmit?.successMessage;
  const failureMessage = formSettings?.formPostSubmit?.failureMessage;
  const postSubmitType = formSettings?.formPostSubmit?.submitType;
  if (!success && !failure) return null;
  if (success && !text[successMessage?.textId]) return null;
  if (failure && !text[failureMessage?.textId]) return null;
  if (postSubmitType !== FormPostSubmitType.Message) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles.feedbackMessage]: true,
      [styles.success]: success,
      [styles.fail]: failure
    })
  }, /*#__PURE__*/React.createElement("div", null, success ? text[successMessage?.textId] : text[failureMessage?.textId]), /*#__PURE__*/React.createElement("button", {
    className: styles.closeButton,
    onClick: resetForm
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
};
export default FeedbackMessage;
//# sourceMappingURL=FeedbackMessage.js.map